import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Key, X } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

/**
 * Banniere persistante affichee en haut de l'app quand l'admin est connecte en
 * mode "Se connecter comme [user]". Permet de revenir a sa session admin en 1 clic.
 */
export function ImpersonationBanner({ user }) {
  const [exiting, setExiting] = useState(false);
  const [impersonator, setImpersonator] = useState(null);

  useEffect(() => {
    // Le backend ne retourne pas le claim impersonator_id dans /auth/me par defaut.
    // On detecte via une heuristique : si l'utilisateur courant n'est pas admin mais que
    // le cookie a une duree courte (1h), on demande au backend explicitement.
    // Pour simplifier : on appelle /api/auth/impersonation-status
    (async () => {
      try {
        const res = await axios.get(`${API}/auth/impersonation-status`, { withCredentials: true });
        if (res.data?.is_impersonating) setImpersonator(res.data.admin_email || 'admin');
      } catch { /* ignore */ }
    })();
  }, []);

  if (!impersonator) return null;

  const handleExit = async () => {
    if (exiting) return;
    setExiting(true);
    try {
      await axios.post(`${API}/admin/end-impersonation`, {}, { withCredentials: true });
      toast.success('Retour à votre session admin');
      window.location.href = '/admin/users';
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erreur sortie impersonation');
      setExiting(false);
    }
  };

  return (
    <div
      className="sticky top-0 z-50 bg-gradient-to-r from-amber-500 to-orange-600 text-white px-4 py-2 shadow-md flex items-center justify-between gap-3 text-sm"
      data-testid="impersonation-banner"
    >
      <div className="flex items-center gap-2 min-w-0 flex-1">
        <Key size={18} weight="bold" className="flex-shrink-0" />
        <span className="truncate">
          <strong>Mode impersonation</strong> — Vous êtes connecté comme <strong>{user?.email}</strong>
          <span className="hidden sm:inline"> (admin : {impersonator})</span>
        </span>
      </div>
      <button
        onClick={handleExit}
        disabled={exiting}
        className="bg-white/20 hover:bg-white/30 px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1 transition"
        data-testid="exit-impersonation-btn"
      >
        <X size={14} weight="bold" />
        Quitter
      </button>
    </div>
  );
}
